import { ROLES } from '@/constants/roles';
// import { DRAWER_TYPES } from '@/constants/drawer';
import { PERMISSIONS } from '@/constants/permissions';

export const personal = {
  path: '/personal/experts/partners',
  name: 'organization-personal',
  // component: () => import('./views/index.vue'),
  meta: {
    title: 'Персонал',
    accessList: [ROLES.organization, ROLES.event_manager],
    visibleIfChildren: true,
    icon: '$iuser-team',
    children: [
      {
        text: 'Эксперты',
        to: { name: 'experts' },
        icon: '$iuser',
        visibleFor: [ROLES.organization, ROLES.event_manager],
        accessFor: [PERMISSIONS.expert_request, PERMISSIONS.expert_create],
        accessArgs: [{}, { all: false }],
      },
      {
        text: 'Event-менеджеры',
        to: { name: 'event-managers' },
        icon: '$iuser',
        visibleFor: [ROLES.organization],
      },
    ],
  },
};

// const PERSONAL_SUBMENU = [
//   {
//     to: '/personal/experts/partners',
//     text: 'Партнеры',
//     icon: 'mdi-account-circle-outline',
//     visibleFor: [
//       ROLES.organization, ROLES.event_manager,
//     ],
//   },
//   {
//     to: '/personal/experts/requests',
//     text: 'Заявки',
//     icon: 'mdi-account-circle-outline',
//     visibleFor: [
//       ROLES.organization, ROLES.event_manager,
//     ],
//     accessFor: [PERMISSIONS.expert_request],
//   },
// ];

export const routes = [
  {
    path: '/personal',
    name: 'organization-personal',
    component: () => import('./views/index.vue'),
    children: [
      {
        path: 'experts',
        name: 'experts',
        component: () => import('./views/experts.vue'),
        meta: {
          title: 'Эксперты',
          accessList: [ROLES.organization, ROLES.event_manager],
        },
      },
      {
        path: 'experts/:id',
        name: 'experts-detail',
        component: () => import('./views/experts-detail.vue'),
        meta: {
          title: 'Информация об эксперте',
          accessList: [ROLES.organization, ROLES.event_manager],
        },
      },
      // {
      //   path: 'experts/partners',
      //   name: 'experts-list',
      //   component: () => import('./views/experts/ExpertsList.vue'),
      //   meta: {
      //     title: 'Эксперты',
      //     subdrawer: DRAWER_TYPES.menu,
      //     drawerChildren: PERSONAL_SUBMENU,
      //     accessList: [ROLES.organization, ROLES.event_manager],
      //   },
      // },
      // {
      //   path: 'experts/requests',
      //   name: 'experts-requests',
      //   component: () => import('./views/experts/ExpertsRequests.vue'),
      //   meta: {
      //     title: 'Заявки',
      //     subdrawer: DRAWER_TYPES.menu,
      //     drawerChildren: PERSONAL_SUBMENU,
      //     accessList: [ROLES.organization, ROLES.event_manager],
      //   },
      // },
      {
        path: 'event/managers',
        name: 'event-managers',
        component: () => import('./views/event-managers.vue'),
        meta: {
          title: 'Event-менеджеры',
          accessList: [ROLES.organization],
        },
      },
    ],
  },
];

export default [
  ...routes,
];
